var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2f15bdd9868c756e8ac45f0a50f11b621ed72595"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["shisha-tone-menu@pluspace"]={id:"2f15bdd9868c756e8ac45f0a50f11b621ed72595"};
      